import apiClient from '@/services/axios'

export async function get(userId, requestObj) {
  var response = await apiClient.post('/users/' + userId + '/award-points', requestObj)
  if (response) {
    return response.data
  }

  throw new Error('Unable to award points.')
}
